var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mask"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mode),expression:"mode"}],staticClass:"maskBox"})])
}
var staticRenderFns = []

export { render, staticRenderFns }